import { render, staticRenderFns } from "./recommender-system.vue?vue&type=template&id=481cbe65&scoped=true&"
import script from "./recommender-system.vue?vue&type=script&lang=js&"
export * from "./recommender-system.vue?vue&type=script&lang=js&"
import style0 from "./recommender-system.vue?vue&type=style&index=0&id=481cbe65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481cbe65",
  null
  
)

export default component.exports